import {
  SUPERADMIN_GET_ALL_RESTAURANT_NOMINATIONS,
  SUPERADMIN_CHANGE_NOMINATION_STATUS,
  SUPERADMIN_GET_NOMINATION_ACTIVITY,
  SUPERADMIN_VIEW_NOMINATION_RESTAURANT,
  SUPERADMIN_VIEW_ALL_REVIEWS,
  SUPERADMIN_CHANGE_REVIEW_STATUS,
  SUPERADMIN_GET_ALL_SUGGESTIONS,
  SUPERADMIN_CHANGE_SUGGESTION_STATUS,
  SUPERADMIN_GET_GLOBAL_CATALOG,
  SUPERADMIN_GET_CHAIN_CATALOG,
  EDIT_GLOBAL_CATALOG,
  EDIT_CHAIN_CATALOG,
  GET_ADMIN_MENU_CATEGORY,
  GET_ADMIN_MENU_CATEGORY_ITEMS,
  SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP,
  SET_ACTIVE_CATEGORY_DATA_MENU_SETUP_ADMIN,
  GET_ADMIN_GLOBAL_ALL_MENU_ITEMS,
  GLOBAL_ADD_CATALOG_ACTIVE_DATA,
  GET_ADMIN_ADDED_TEMPLATES_GLOBAL,
  GET_ADMIN_ADDED_TEMPLATES_CHAIN,
  GET_ALL_EVENTS_ADMIN,
  GET_ONLINE_EVENT,
  EVENT_DETAILS_ADMIN,
  ADMIN_EDIT_EVENT_DETAILS_ADMIN,
  SET_CATEGORY_CHAIN_DATE,
} from "../../types";

const initialState = {
  allRestaurantNominations: [],
  allNominationsActivity: [],
  viewNominationsByRestaurant: [],
  allReviews: [],
  allSuggestions: [],
  allGLobalCatalog: [],
  allChainCatalog: [],
  editGlobalCatalog: { edit: false },
  editChainCatalog: { edit: false },
  menuCategory: [],
  menuCategoryItems: [],
  activeItemId: "",
  activeCategoryData: [],
  all_menu_items_global: [],
  active_global_catalog: {},
  admin_global_templates: [],
  admin_chain_templates: [],
  all_events: [],
  online_event: [],
  event_details: {},
  admin_event_details: {},
  activeLastDate: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_CATEGORY_CHAIN_DATE:
      return {
        ...state,
        activeLastDate: payload,
      };
    case SUPERADMIN_GET_ALL_RESTAURANT_NOMINATIONS:
      return {
        ...state,
        allRestaurantNominations: payload,
      };

    case SUPERADMIN_CHANGE_NOMINATION_STATUS:
      var changeNominationStatus = Object.assign(
        state.allRestaurantNominations
      );
      let changeStatus = state.allRestaurantNominations.data.map(
        (nomination) => {
          if (nomination._id === payload.id) {
            return {
              ...nomination,
              status: payload.status,
            };
          } else {
            return nomination;
          }
        }
      );
      delete changeNominationStatus["data"];
      changeNominationStatus.data = changeStatus;
      return {
        ...state,

        allRestaurantNominations: {
          ...state.allRestaurantNominations,
        },
      };

    case SUPERADMIN_GET_NOMINATION_ACTIVITY:
      return {
        ...state,
        allNominationsActivity: payload,
      };
    case SUPERADMIN_VIEW_NOMINATION_RESTAURANT:
      return {
        ...state,
        viewNominationsByRestaurant: payload,
      };
    case SUPERADMIN_VIEW_ALL_REVIEWS:
      return {
        ...state,
        allReviews: payload,
      };
    case SUPERADMIN_CHANGE_REVIEW_STATUS:
      var filterCheck = payload.filterType;

      if (filterCheck !== "ALL") {
        var updateStatus = state.allReviews.filter((review) => {
          return review._id !== payload.id;
        });
        return {
          ...state,
          allReviews: updateStatus,
        };
      } else {
        let updateStatus = state.allReviews.map((review) => {
          if (review._id === payload.id) {
            return {
              ...review,
              status: payload.status,
            };
          } else {
            return review;
          }
        });
        return {
          ...state,
          allReviews: updateStatus,
        };
      }
    case SUPERADMIN_GET_ALL_SUGGESTIONS:
      return {
        ...state,
        allSuggestions: payload,
      };
    case SUPERADMIN_CHANGE_SUGGESTION_STATUS:
      var changeSuggestionStatus = Object.assign(state.allSuggestions);
      let changeStatuss = state.allSuggestions.data.map((suggestion) => {
        if (suggestion._id === payload.id) {
          return {
            ...suggestion,
            status: payload.status,
          };
        } else {
          return suggestion;
        }
      });
      delete changeSuggestionStatus["data"];
      changeSuggestionStatus.data = changeStatuss;
      return {
        ...state,
        allSuggestions: {
          ...state.allSuggestions,
        },
      };

    case SUPERADMIN_GET_GLOBAL_CATALOG:
      return {
        ...state,
        allGLobalCatalog: payload,
      };
    case SUPERADMIN_GET_CHAIN_CATALOG:
      return {
        ...state,
        allChainCatalog: payload,
      };
    case EDIT_GLOBAL_CATALOG:
      return {
        ...state,
        editGlobalCatalog: payload,
      };
    case EDIT_CHAIN_CATALOG:
      return {
        ...state,
        editChainCatalog: payload,
      };
    case GET_ADMIN_MENU_CATEGORY:
      return {
        ...state,
        menuCategory: payload,
      };
    case GET_ADMIN_MENU_CATEGORY_ITEMS:
      return {
        ...state,
        menuCategoryItems: action.payload,
      };
    case SET_ACTIVE_ITEM_ID_ADMIN_MENU_SETUP:
      return {
        ...state,
        activeItemId: action.payload,
      };

    case SET_ACTIVE_CATEGORY_DATA_MENU_SETUP_ADMIN:
      return {
        ...state,
        activeCategoryData: action.payload,
      };

    case GET_ADMIN_GLOBAL_ALL_MENU_ITEMS:
      return {
        ...state,
        all_menu_items_global: action.payload,
      };
    case GLOBAL_ADD_CATALOG_ACTIVE_DATA:
      return {
        ...state,
        active_global_catalog: action.payload,
      };

    case GLOBAL_ADD_CATALOG_ACTIVE_DATA:
      return {
        ...state,
        active_global_catalog: action.payload,
      };
    case GET_ADMIN_ADDED_TEMPLATES_GLOBAL:
      return {
        ...state,
        admin_global_templates: action.payload,
      };

    case GET_ADMIN_ADDED_TEMPLATES_CHAIN:
      return {
        ...state,
        admin_chain_templates: action.payload,
      };

    case GET_ALL_EVENTS_ADMIN:
      return {
        ...state,
        all_events: action.payload,
      };
    case GET_ONLINE_EVENT:
      return {
        ...state,
        online_event: action.payload,
      };
    case EVENT_DETAILS_ADMIN:
      return {
        ...state,
        event_details: action.payload,
      };
    case ADMIN_EDIT_EVENT_DETAILS_ADMIN:
      return {
        ...state,
        admin_event_details: action.payload,
      };

    default:
      return state;
  }
}
